import script from "./FormTabs.vue?vue&type=script&lang=js"
export * from "./FormTabs.vue?vue&type=script&lang=js"

import "./FormTabs.vue?vue&type=style&index=0&id=5ab065da&lang=scss"

const __exports__ = script;

export default __exports__